import { useState } from 'react';

const useToggle = initialValue => {
  const [value, setValue] = useState(initialValue || false);

  return [value, () => setValue(!value)];
};

export default useToggle;
